import { DEMO_SUBDOMAINS, DemoSubdomainVariants } from './constants';

type PossibleSubdomains =
  | DemoSubdomainVariants
  | `control-${DemoSubdomainVariants}`
  | 'control';

export const BASE_HOST = API_HOST || 'stripcash.com';

const getApiConfigBySubdomain = (
  hostname: Document['location']['hostname'] = document.location.hostname,
) =>
  DEMO_SUBDOMAINS.reduce(
    (acc, subdomain) => ({
      ...acc,
      [subdomain]: `api-${subdomain}.${BASE_HOST}`,
      [`control-${subdomain}`]: `control-${subdomain}.${BASE_HOST}`,
    }),
    { [`control`]: API_HOST || hostname } as Record<PossibleSubdomains, string>,
  );

export default getApiConfigBySubdomain;
